import {TabsActionTypes} from './types';
import {AppStore} from "../../desktop";
import {Tab} from "../../tabs/Tab";

export const actionAddTab = (tab: Tab) => {
	AppStore.dispatch({type: TabsActionTypes.ADD, payload: tab})
}

export const actionDeleteTab = (tab: Tab) => {
	AppStore.dispatch({type: TabsActionTypes.DELETE, payload: tab})
}

export const actionDeleteTabForItemId = (id: string) => {
	AppStore.dispatch({type: TabsActionTypes.DELETE_FOR_ITEM, payload: id})
}

export const actionSetActiveTab = (tab: Tab) => {
	AppStore.dispatch({type: TabsActionTypes.SET_ACTIVE, payload: tab})
}

export const actionSetTabState = (state: any) => {
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_STATE, payload: state})
}

export const actionSetTabStateItem = (item: any) => {
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_STATE_ITEM, payload: item})
}

export const actionSetTabItem = (item: any) => {
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: item})
}

export const actionUpdateTabStateItem = (item: any, elementName: string, index: number) => {
	AppStore.dispatch({type: TabsActionTypes.UPDATE_TAB_STATE_ITEM, payload: {item: item, elementName: elementName, index: index}})
}

export const actionActiveTabTitle = (title: string) => {
	AppStore.dispatch({type: TabsActionTypes.SET_ACTIVE_TAB_TITLE, payload: title})
}


